// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__20WEz","header":"PatientQuestionnaire_header__1dT-A","info":"PatientQuestionnaire_info__SZBOt"};